import { FormattedMessage } from 'react-intl'

import LinkifiedString from '@components/UI/LinkifiedString'
import Theme from '@theme'
import CampaignPreviewBlock from '../Block'
import { BlockText } from '../Block/Block.styled'

export interface ICampaignPreviewDeliverablesProps {
  text?: string
}

const CampaignPreviewDeliverables = ({ text }: ICampaignPreviewDeliverablesProps) =>
  text ? (
    <CampaignPreviewBlock title={<FormattedMessage id="builder.brief.deliverables.header" />}>
      <BlockText small color={Theme.grey800Color}>
        <LinkifiedString value={text} color={Theme.primaryColor} preserveLineBreaks />
      </BlockText>
    </CampaignPreviewBlock>
  ) : null

export default CampaignPreviewDeliverables
